import { number_array_or_empty } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
export const week_timetable_fields = [{ name: 'temp7', ...number_array_or_empty }];
function weekTimetables2Str(obj_id, obj) {
    return new ObjectLine(obj.id, obj_id, obj.temp7);
}
function weekTimetablesFromStr(id, params) {
    return {
        id: id,
        temp7: params,
    };
}
export const week_timetable_parser = {
    toStr: weekTimetables2Str,
    fromStr: weekTimetablesFromStr,
};
